'use client';

import { useSearchParams } from 'next/navigation';
import React, { Suspense } from 'react';

// Internal component to handle the logic safely inside Suspense
function LayoutLogic({
  children,
  header,
  footer,
  checkUser,
}: {
  children: React.ReactNode;
  header: React.ReactNode;
  footer: React.ReactNode;
  checkUser: React.ReactNode;
}) {
  const searchParams = useSearchParams();
  const isApp = searchParams.get('app') === 'true';

  // If ?app=true, return only children (hide everything else)
  if (isApp) {
    return <>{children}</>;
  }

  // Otherwise, show the full layout
  return (
    <>
      {header}
      {checkUser}
      {children}
      {footer}
    </>
  );
}

export default function LayoutWrapper(props: any) {
  return (
    // Suspense is REQUIRED when using useSearchParams to avoid build errors
    // fallback={props.children} ensures the content shows while params load
    <Suspense fallback={<>{props.children}</>}>
      <LayoutLogic {...props} />
    </Suspense>
  );
}
